import {Model} from "./Model";
import {
    IApiMatch, IApiRankingEntry, IApiMatchContestantPoints, IApiMatchContestantScore,
    IApiMatchResultRound, IApiMatchRound, IApiMatchParameter
} from "../typings/apiResponse";
import {IRankingEntry, RankingEntry} from "./Ranking";
import * as angular from "angular";

export class MatchState {
    static CHALLENGE: string = 'challenge';
    static PROTEST: string = 'protest';
    static OPEN: string = 'open';
    static CLOSED: string = 'closed';
    static EXCEPTION: string = 'exception';
}

export class Match extends Model {
    constructor (private apiData: IApiMatch) {
        super(apiData);
    }

    getId(): number {
        return this.apiData.id;
    }

    getStatus(): string {
        return this.apiData.status;
    }

    getLeagueId(): string {
        return this.apiData.leagueId;
    }

    getMatchRankingEntries(): IRankingEntry[] {
        var contestants: Array<IRankingEntry> = [];

        angular.forEach(this.apiData.contestants, (contestant: IApiRankingEntry) => {
            contestants.push(new RankingEntry(contestant));
        });

        return contestants;
    }

    getRankingEntries(): Array<IApiRankingEntry> {
        return this.apiData.contestants;
    }

    isTeam(): boolean {
        return angular.isDefined(this.apiData.contestants[0].team) || angular.isDefined(this.apiData.contestants[1].team);
    }

    containsContestant(id: string): boolean {
        return this.isTeam() ?
        (this.apiData.contestants[0].team.id === id || this.apiData.contestants[1].team.id === id)
            :
        (this.apiData.contestants[0].user.id === id || this.apiData.contestants[1].user.id === id);
    }

    getRankingEntry(id: string): IRankingEntry {
        if ((this.isTeam() ? this.apiData.contestants[0].team.id : this.apiData.contestants[0].user.id) === id) {
            return new RankingEntry(this.apiData.contestants[0]);
        }

        if ((this.isTeam() ? this.apiData.contestants[1].team.id : this.apiData.contestants[1].user.id) === id) {
            return new RankingEntry(this.apiData.contestants[1]);
        }

        return null;
    }

    getOpponent(id: string): IRankingEntry {
        if ((this.isTeam() ? this.apiData.contestants[0].team.id : this.apiData.contestants[0].user.id) === id) {
            return new RankingEntry(this.apiData.contestants[1]);
        }

        return new RankingEntry(this.apiData.contestants[0]);
    }

    getGameAccount(id: string): string {
        return this.apiData.gameaccounts[id];
    }

    //ApiMatch.result object
    getPlayedRounds(): number {
        return this.apiData.result.playedRounds;
    }

    getPoints(): IApiMatchContestantPoints {
        return this.apiData.result.points;
    }

    getScore(): IApiMatchContestantScore {
        return this.apiData.result.score;
    }

    getRounds(): IApiMatchResultRound[] {
        return this.apiData.result.rounds;
    }

    getType(): string {
        return this.apiData.type;
    }

    getBeginAt(): Date {
        return new Date(this.apiData.beginAt);
    }
    getCalculatedAt(): Date {
        return new Date(this.apiData.calculatedAt);
    }

    getRound(): IApiMatchRound {
        return this.apiData.round;
    }

    getScoreByContestantId(id: number): number {
        return this.apiData.result.score[id];
    }

    getWinner(): IRankingEntry {
        var tempContestants: Array<IApiRankingEntry> = this.getRankingEntries();

        if (this.isDefwin()) {

            if (this.isTeam() ? !tempContestants[0].team.id : !tempContestants[0].user.id) {
                return new RankingEntry(tempContestants[1]);
            } else {
                return new RankingEntry(tempContestants[0]);
            }

        }

        var scoreContestant1;
        var scoreContestant2;

        if (this.isTeam()) {
            scoreContestant1 = this.getScoreByContestantId(parseInt(tempContestants[0].team.id));
            scoreContestant2 = this.getScoreByContestantId(parseInt(tempContestants[1].team.id));
        } else {
            scoreContestant1 = this.getScoreByContestantId(parseInt(tempContestants[0].user.id));
            scoreContestant2 = this.getScoreByContestantId(parseInt(tempContestants[1].user.id));
        }

        if (scoreContestant1 > scoreContestant2) {
            return new RankingEntry(tempContestants[0]);
        } else if (scoreContestant2 > scoreContestant1) {
            return new RankingEntry(tempContestants[1]);
        } else {
            // In case of tie
            return null;
        }

    }

    isDefwin(): boolean {
        var tempContestants: Array<IApiRankingEntry> = this.getRankingEntries();

        return !!(this.isTeam() ? !tempContestants[0].team.id || !tempContestants[1].team.id : !tempContestants[0].user.id || !tempContestants[1].user.id);
    }

    getAllParameterNames(): Array<string> {
        var tempNames: Array<string> = [];

        angular.forEach(this.apiData.parameters, (parameter: IApiMatchParameter) => {
            tempNames.push(parameter.name)
        });

        return tempNames;
    }

    getSelectedParameterValue(name: string): string {
        var tempSelected: string = "";

        angular.forEach(this.apiData.parameters, (parameter: IApiMatchParameter) => {
            if (parameter.name == name) {
                tempSelected = parameter.selected;
            }
        });

        return tempSelected;
    }

    getParameterOptions(name: string): Array<string> {
        var tempOptions: Array<string> = [];

        angular.forEach(this.apiData.parameters, (parameter: IApiMatchParameter) => {
            if (parameter.name == name) {
                tempOptions = parameter.value.split(",");
            }
        });

        return tempOptions;
    }
}
